import {
  Component,
  EventEmitter,
  Input,
  Output,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Account } from '../../../models/account/account';
import { StreetAddressComponent } from '../../street-address/street-address.component';
import { TextInputComponent } from '../../ui/controls/text-input/text-input.component';
import { DdlInputComponent } from '../../ui/controls/ddl-input/ddl-input.component';
import { AccountService } from '../../../models/account/accountService';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import {
  FormValidator,
  ValidationMessage,
} from '../../../models/validation/formValidator';
import { iValidatedControl } from '../../ui/controls/iValidatedControl';
import { StreetAddress } from '../../../models/streetAddress/streetAddress';
import { FormMode } from '../../../core/constants';
import { CacheService } from '../../../core/storage/cacheService';
import { BaseComponent } from '../../baseComponent';
import { Logging } from '../../../core/logging';
import { ListItem } from '../../../../../../../libs/Shared/components/model/listItem';

@Component({
  selector: 'app-account-billing-form',
  templateUrl: './account-billing-form.component.html',
  standalone: false,
})
export class AccountBillingFormComponent extends BaseComponent {
  //declare function scrollToTop(selector:string): void;

  @Input() account: Partial<Account> = Account.createEmpty();
  @Input() enableEditing: boolean = false;
  //@Input() mode: string = "view";
  @Input() mode: FormMode = FormMode.View;
  @Input() enableDataStore: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  @ViewChild(StreetAddressComponent) billingAddressForm:
    | StreetAddressComponent
    | undefined;
  @ViewChildren(TextInputComponent) validatedTextBoxes:
    | QueryList<TextInputComponent>
    | undefined;
  @ViewChildren(DdlInputComponent) validatedDropDowns:
    | QueryList<DdlInputComponent>
    | undefined;

  data: Partial<Account> = Account.createEmpty();

  accountHolderOptions: ListItem[] = CacheService.bankHolderTypesList;
  accountTypeOptions: ListItem[] = CacheService.bankAccountTypesList;

  constructor(
    public accountService: AccountService,
    private uiErrorHandler: UIErrorHandler,
    private formValidator: FormValidator,
  ) {
    super();
  }

  ngOnInit() {
    if (this.account != undefined) {
      this.data.id = this.account.id;
      this.copyModelData(this.account, this.data);
    }
  }

  public get formMode(): typeof FormMode {
    return FormMode;
  }

  public validate(): ValidationMessage[] {
    let errors: ValidationMessage[] = [];

    let validatedControls: iValidatedControl[] = [];
    if (this.validatedTextBoxes && this.validatedDropDowns) {
      validatedControls = validatedControls.concat(
        this.validatedTextBoxes.toArray(),
      );
      validatedControls = validatedControls.concat(
        this.validatedDropDowns.toArray(),
      );

      errors = this.formValidator.validate(validatedControls);
    }

    if (this.billingAddressForm) {
      errors = errors.concat(this.billingAddressForm.validate());
    } else {
      this.uiErrorHandler.handleError('No billing address found');
    }

    return errors;
  }

  public getData(merchantData: Partial<Account>) {
    merchantData.billingAccountHolderType = this.data.billingAccountHolderType;
    merchantData.billingAccountNum = this.data.billingAccountNum;
    merchantData.billingAccountType = this.data.billingAccountType;
    merchantData.billingName = this.data.billingName;
    merchantData.billingRoutingNum = this.data.billingRoutingNum;
    merchantData.billingAddress = this.data.billingAddress;
  }

  private copyModelData(
    source: Partial<Account>,
    destination: Partial<Account>,
  ) {
    destination.billingAccountNum = source.billingAccountNum;
    destination.billingRoutingNum = source.billingRoutingNum;
    destination.billingAccountHolderType = source.billingAccountHolderType;
    destination.billingAccountType = source.billingAccountType;

    if (source.billingAddress) {
      destination.billingAddress = StreetAddress.clone(source.billingAddress);
    } else {
      destination.billingAddress = StreetAddress.createEmpty();
    }
  }

  public btnEdit_click() {
    this.copyModelData(this.account, this.data);
    this.mode = FormMode.Edit;
  }

  public btnSaveClick() {
    var that = this;

    this.accountService
      .patchBillingInfo(this.data)
      .then(() => {
        this.copyModelData(that.data, that.account);
        //this.copyModelData(savedMerchant, that.data);

        that.mode = FormMode.View;
        //scrollToTop("billingInformationContainer");

        this.saved.emit(true);
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public btnCancelClick() {
    this.copyModelData(this.account, this.data);

    this.mode = FormMode.View;
    //scrollToTop("billingInformationContainer");
    this.saved.emit(false);
  }
}
